import { useVuelidate } from '@vuelidate/core'
import ErrorList from './ErrorList'

export default {
  props: ['formData', 'formOptions', 'formLabels'],
  components: {
    ErrorList
  },
  methods: {
    setErrorId(fieldName) {
      const errors = this.v$.formData[fieldName].$errors
      return errors.length ? `errors--${fieldName}` : null
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
      formData: {
        generalAdvertisingAccepted: {}
      }
    }
  },
  template: `
    <div style="margin-top: 30px;">
        <h3>Allgemeine Werbeerlaubnis</h3>
        <p>Damit wir Sie zu Ihrem Versicherungsschutz und passenden Angeboten beraten und informieren können, benötigen wir Ihre Einwilligung.</p>
        <div class="form__checkbox-outer">
        
            <label class="form__label">
                <input :aria-describedby="setErrorId('generalAdvertisingAccepted')" required type="checkbox" v-model="formData.generalAdvertisingAccepted" name="generalAdvertisingAccepted" value="1" class="form__checkbox">
                {{formLabels['generalAdvertisingAccepted']}}
            </label>
            <error-list :errors="v$.formData.generalAdvertisingAccepted.$errors" :id="setErrorId('generalAdvertisingAccepted')"/>
        </div>
    </div>
    
    
    <div style="margin-top: 30px;">
        <h3>Allgemeiner Datenschutzhinweis</h3>
        <p>Die Erhebung der Sozialdaten ist für die ordnungsgemäße Durchführung der Krankenversicherung erforderlich und nach den Vorschriften des Fünften Buches Sozialgesetzbuch (SGB V) zulässig. Ihre Angaben werden vertraulich behandelt und unterliegen dem Datenschutz. Die datenschutzrechtlichen Hinweise und Informationen zur Verarbeitung Ihrer Daten finden Sie auf unserer Webseite unter <a href="https://www.bkkgs.de/datenschutz" title="Datenschutz" target="_blank">www.bkkgs.de/datenschutz</a>.</p>
    </div>
    
    `
}
